import type { Latest } from '../../types/mes/applet-designs/appletDesign.latest.zod';
import { AppletDesignVersionConfig_V3 } from '../../types/mes/applet-designs/v3/appletDesign.v3.zod';
import { upgradeFromV3ToV4 } from './migration-functions/v3tov4';
import { latestAppletDesignVersionNumber } from '@redviking/argonaut-util/types/mes/applet-designs/latest/schemaVersion';

export const updateDesign = (incomingCfg: unknown): Latest.AppletDesignVersionConfig => {
    if (typeof incomingCfg !== 'object') {
        throw new Error(`Applet Design config is of type: ${typeof incomingCfg}.`);
    }
    if (incomingCfg === null) {
        throw new Error('Applet Design config is null.');
    }
    if (!('schemaVersion' in incomingCfg)) {
        throw new Error('Applet Design does not have a schema version.');
    }
    const schemaVersion = incomingCfg.schemaVersion;
    if (typeof schemaVersion !== 'number' || schemaVersion < 0 || schemaVersion > latestAppletDesignVersionNumber) {
        throw new Error(`Applet Design config has invalid schema version: ${schemaVersion}.`);
    }
    if (incomingCfg.schemaVersion === 3) {
        // FUTURE validate this is a valid v3 config
        return upgradeFromV3ToV4(incomingCfg as AppletDesignVersionConfig_V3);
    } else if (incomingCfg.schemaVersion === latestAppletDesignVersionNumber) {
        return incomingCfg as Latest.AppletDesignVersionConfig;
    } else {
        throw new Error(`Applet Design with schema version ${schemaVersion} cannot me migrated.`);
    }
};
